import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';
import { NavItemBaseProps } from 'src/components/nav-section/types';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () =>
      [
        // OVERVIEW
        // ----------------------------------------------------------------------
        {
          subheader: 'overview',
          items: [
            {
              title: 'Restaurants',
              path: paths.dashboard.restaurants,
              icon: ICONS.dashboard,
              permissions: ['partners:misc:handle_multiple_restaurants'],
            },
            {
              title: 'Customers',
              path: paths.dashboard.customers.list,
              icon: <Iconify icon="streamline:information-desk-customer" />,
              permissions: ['partners:read:customers'],
              // Customer Support
            },
            {
              title: 'Restaurant Info',
              path: paths.dashboard.profile,
              icon: ICONS.user,
              permissions: ['partners:read:restaurants'],
              except: ['partners:misc:handle_multiple_restaurants'],
            },
            {
              title: 'Plan Groups',
              path: paths.dashboard.restaurant.plangroup.plangroups,
              icon: <Iconify icon="charm:package" />,
              permissions: ['partners:read:plangroups'],
              except: ['partners:misc:handle_multiple_restaurants'],
            },
            // {
            //   title: 'Plans',
            //   path: paths.dashboard.restaurant.plan.plans,
            //   icon: <Iconify icon="charm:package" />,
            //   permissions: ['partners:read:plans'],
            //   except: ['partners:misc:handle_multiple_restaurants'],
            // },
            {
              title: 'Food',
              path: paths.dashboard.restaurant.food.foods,
              icon: <Iconify icon="dashicons:food" />,
              permissions: ['partners:read:foods'],
              except: ['partners:misc:handle_multiple_restaurants'],
              // Content Creator
            },
            // {
            //   title: 'Users',
            //   path: paths.dashboard.users.list,
            //   icon: <Iconify icon="streamline:information-desk-customer" />,
            // },
            // {
            //   title: 'Sub Users',
            //   path: paths.dashboard.sub_users.list,
            //   icon: <Iconify icon="raphael:user" />,
            // },
          ],
        },
        {
          subheader: "Selected Food",
          items: [
            {
              title: 'Food',
              path: paths.dashboard.selectedFoods.foods,
              icon: <Iconify icon="ep:food" />,
              permissions: ['partners:read:selectedfood'],
            },
            {
              title: 'Ingredients',
              path: paths.dashboard.selectedFoods.ingredients,
              icon: <Iconify icon="mdi:food-variant" />,
              permissions: ['partners:read:selectedfood'],
            },
            {
              title: 'Customers',
              path: paths.dashboard.selectedFoods.customers,
              icon: <Iconify icon="streamline:information-desk-customer" />,
              permissions: ['partners:read:selectedfood'],
            },
            {
              title: 'Stickers',
              path: paths.dashboard.selectedFoods.stickers,
              icon: <Iconify icon="mdi:sticker-outline" />,
              permissions: ['partners:read:selectedfood'],
            },
            {
              title: 'Print/Excel',
              path: paths.dashboard.selectedFoods.printExcel,
              icon: <Iconify icon="mdi:file-excel" />,
              permissions: ['partners:read:selectedfood'],
            },
          ],
        },
        {
          subheader: 'Management',
          icon: ICONS.analytics,
          items: [
            // {
            //   title: 'Transactions',
            //   path: paths.dashboard.transactions,
            //   icon: ICONS.banking,
            //   permissions: ['partners:read:transactions', 'partners:misc:handle_multiple_restaurants'],
            // },
            {
              title: 'Deliveries',
              path: paths.dashboard.deliveries,
              icon: ICONS.order,
              permissions: ['partners:read:deliveries'],
              // Deliveries
            },
            {
              title: 'Graphics',
              path: paths.dashboard.performance.graphics,
              icon: ICONS.analytics,
              permissions: ['partners:read:graphics'],
              // Performance
            },
            // {
            //   title: 'Summary',
            //   path: paths.dashboard.performance.summary,
            //   icon: <Iconify icon="grommet-icons:document-performance" />,
            //   permissions: ['partners:read:summary'],
            //   // Performance
            // },

            {
              title: 'Subscriptions',
              path: paths.dashboard.restaurant.subscription.subscriptions,
              icon: <Iconify icon="mdi:card-account-details-outline" />,
              permissions: ['partners:read:subscriptions'],
              // Performance
            },
            {
              title: 'Discounts',
              path: paths.dashboard.restaurant.discount.discounts,
              icon: <Iconify icon="mdi:percent" />,
              permissions: ['partners:read:discounts'],
            },
          ],
        },
      ] as {
        subheader: string;
        items: NavItemBaseProps[];
      }[],
    []
  );

  return data;
}
